import React, { Component, useEffect } from 'react';
import {BrowserRouter as Router, Routes as Switch, Route, useLocation, useNavigate} from 'react-router';
import {AboutPage} from './AboutPage';
import {Imprint} from './Imprint';
import {ItemList} from './ItemList';
import {Header} from './Header';

export class Routes extends Component {
  render() {
    return (
      <Router>

          {/* if is initial render and pathname="/" redirect to intro  */}
          <RedirectToIntro />

          <Header />


          <Switch>

            {/* if url fits "/info" render AboutPage */}
            <Route path="/about" element={ <AboutPage {...this.props} /> } />
            <Route path="/imprint" element={ <Imprint {...this.props} /> } />

            {/* if not "/info" render ItemList, which reads the "/:slug" match itself */}
            <Route path="*" element={ <ItemList {...this.props} /> } />

          </Switch>

      </Router>
    );
  }
}

const RedirectToIntro = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(location.pathname==="/"){
      navigate('/intro');
    }
    // only on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
